<template>
  <q-page class="flex column home page-layout">
    <div class="grid-container-2-columns-stacked">
      <section class="grid-container-2-columns-stacked__item--full-row">
        <q-card flat class="table-card">
          <q-card-section class="table-card__section">
            <FileExplorer title="Evolve" dataset="document/2" :timer="180000" />
          </q-card-section>
        </q-card>
      </section>
    </div>
  </q-page>
</template>

<script>
import FileExplorer from "@/components/other/FileExplorer.vue";

export default {
  name: "Evolve",
  data() {
    return {
      filterOption: {
        siteId: 0,
        networkId: 0,
        operatorId: 0,
      },
    };
  },
  components: {
    FileExplorer,
  },
};
</script>
